import { useTranslation } from 'react-i18next';

import { gql, useMutation } from '@apollo/client';
import { showNotification, NOTIFICATION_TYPE } from '@thinknet-gmbh/platform-common-ui';

export const SUBSCRIBE = gql`
  mutation ($payload: SubscribeInput!) {
    subscribe(payload: $payload) {
      _id
    }
  }
`;

export const useSubscribe = () => {
  const { t: globalExceptionsT } = useTranslation('common', { keyPrefix: 'exceptions' });

  const [subscribe, { loading }] = useMutation(SUBSCRIBE, {
    onError: (error: any) =>
      showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: globalExceptionsT('internalError'),
        ...(error && { description: error.message || error.errorMessage }),
      }),
  });

  return {
    loading,
    subscribe: (subscribeData: any) => subscribe({ variables: { payload: subscribeData } }),
  };
};
